import React from 'react';

function NoAccess() {
    return (<>
        NoAccess
    </>)
}

export default NoAccess;
